var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"component system-notice"},[_c('common-title',{attrs:{"title":"系统公告","showIcon":false}}),_c('el-input',{attrs:{"type":"textarea","readonly":"","placeholder":"暂无公告","rows":3,"maxlength":"200"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }